export default {
  computed: {
    runningBatch() {
      if (! this.lastBatch) {
        return false;
      }

      return !['finished', 'warnings', 'failed', 'canceled'].includes(this.lastBatch?.phase)
    }
  }
}
